import { useEffect, useState } from "react";
import { auth, db } from "@/lib/firebase";
import { doc, getDoc } from "firebase/firestore";

type Status = {
  loading: boolean;
  completed: boolean;
  error?: string;
};

export function useOnboardingStatus(): Status {
  const [state, setState] = useState<Status>({ loading: true, completed: false });

  useEffect(() => {
    let alive = true;
    async function run() {
      const u = auth.currentUser;
      if (!u) {
        if (alive) setState({ loading: false, completed: false });
        return;
      }
      try {
        const snap = await getDoc(doc(db, "users", u.uid));
        const completed = !!snap.data()?.onboarding?.completedAt;
        if (alive) setState({ loading: false, completed });
      } catch (e: any) {
        if (alive) setState({ loading: false, completed: false, error: e?.message });
      }
    }
    run();
    const unsub = auth.onAuthStateChanged(() => run());
    return () => {
      alive = false;
      unsub();
    };
  }, []);

  return state;
}
